import React from 'react';
import { Building, Phone, Globe } from 'react-bootstrap-icons';

const ContactInfo = () => {
  return (
    <div className='container'>
    <div className="row text-center my-5">
      <div className="col-md-4">
        <Building className="mb-3 mx-auto text-warning" size={60} />
        <h5>Address</h5>
        <p className="text-muted">
          2945 1st Ave Market Street<br />
          USA, North England
        </p>
      </div>
      <div className="col-md-4">
        <Phone className="mb-3 mx-auto text-warning" size={60} />
        <h5>Phone</h5>
        <p className="text-muted">
          +123 456 678 890<br />
          +123 456 678 890
        </p>
      </div>
      <div className="col-md-4">
        <Globe className="mb-3 mx-auto text-warning" size={60} />
        <h5>Website</h5>
        <p className="text-muted">
          info@example.com<br />
          www.example.com
        </p>
      </div>
    </div>
    </div>
  );
}

export default ContactInfo;
